<template>
    <h5>Payments</h5>
    <div class="table-responsive text-nowrap">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th>Invoice #</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Mode of Payment</th>
                    <th>Date</th>
                </tr>
            </thead>
            <tbody class="table-border-bottom-0">

                <tr v-if="!payments || payments.length === 0">
                    <td colspan="5" style="text-align: center;">No payment found.</td>
                </tr>

                <tr v-else v-for="item in payments"  :key="item.subscription_id">
                    <td>
                        <strong>{{ item.invoice_number }}</strong> 
                    </td>
                    <td>{{ item.amount }}</td>
                    <td>
                        <span :class="['badge', getStatusClass(item.status)]">
                            {{ item.status }}
                        </span>
                    </td>
                    <td>{{ item.mode }}</td>
                    <td>{{ item.date }}</td>
                </tr>
                
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        props: {
            payments: {
                type: Array,
                default: () => [],
            },
        },
        methods: {
            getStatusClass(status) {
                let bg = 'danger';
                if(status == 'success')
                    bg = 'success';

                return 'bg-label-' + bg.toLowerCase();
            }
        }
    };
</script>
